import { disablePageScroll, enablePageScroll } from 'scroll-lock'

const mobileNav = document.querySelector('.navigation--mobile')
const mobileOpen = document.querySelectorAll('[data-mobile-open]')
const mobileClose = document.querySelectorAll('[data-mobile-close]')

mobileOpen.forEach(el => {
    el.addEventListener('click', (event) => {
        disablePageScroll(mobileNav)
    })
})

mobileClose.forEach(el => {
    el.addEventListener('click', (event) => {
        enablePageScroll(mobileNav)
    })
})
